import BaseResource from './BaseResource'

export default class Roles extends BaseResource {
  static endpoint = '/api/v1/roles' ///profile
}
